'use client';

/* ==================================================================
   Vertical-scrolling testimonials column
   Pure CSS keyframe animation (no motion library needed).
   The track contains the items twice and translates -50% to loop.
   ================================================================== */

export default function TestimonialsColumn({
  testimonials,
  duration = 15,
  className = '',
}) {
  const items = [...testimonials, ...testimonials];
  return (
    <div className={className}>
      <div
        className="testimonials-track flex flex-col gap-6 pb-6"
        style={{ ['--testimonials-duration']: `${duration}s` }}
      >
        {items.map((t, i) => (
          <div
            key={i}
            className="w-full max-w-xs rounded-3xl border border-gray-200/80 bg-white p-7 shadow-[0_10px_30px_-15px_rgba(5,139,240,0.18)]"
          >
            <p className="text-[14px] leading-relaxed text-[#0a1b3a]/85">
              {t.text}
            </p>
            <div className="mt-5">
              <div className="text-sm font-semibold leading-tight tracking-tight text-[#0a1b3a]">
                {t.name}
              </div>
              <div className="mt-1 text-xs leading-tight tracking-tight text-[#0a1b3a]/55">
                {t.company}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
